<template>
  <v-expansion-panels>
    <v-expansion-panel>
      <v-expansion-panel-header>
        <div class="collapsable-header">
          <div class="bold mb">E-Mail Adresse</div>
          <div class="">Verwalte deine E-Mail Adresse</div>
        </div>
      </v-expansion-panel-header>
      <v-expansion-panel-content>
        <div class="settings-collapsable-inner">
          <div class="settings-collapsable-left">
            <div class="input-text-wrapper no-m">
              <label for="email" class="input-label">E-Mail Adresse</label>

              <input
                id="email"
                type="email"
                class="input-text input-text-border"
                name="email"
                required
                autocomplete="new-password"
                v-model="email"
              />
            </div>
          </div>
          <div class="settings-collapsable-right">
            <div class="err-succ-messages">
              <div class="success-message">
                {{ successMessage }}
              </div>
              <div class="error-message">
                {{ errorMessage }}
              </div>
            </div>
            <button @click.prevent="changeEmail()" class="btn btn-blue">
              E-Mail Adresse ändern
            </button>
          </div>
        </div>
      </v-expansion-panel-content>
    </v-expansion-panel>
  </v-expansion-panels>
</template>

<script>
export default {
  props: ["current"],
  data() {
    return {
      email: this.current,
      errorMessage: null,
      successMessage: null,
    };
  },
  watch: {},
  methods: {
    changeEmail() {
      this.errorMessage = null;
      this.successMessage = null;
      axios
        .post("/changeMail", {
          email: this.email,
        })
        .then((res) => {
          console.log(res);
          this.successMessage =
            "Deine E-Mail Adresse wurde erfolgreich geändert.";
        })
        .catch((error) => {
          console.log(error.response);

          if (error.response.status === 422) {
            this.errorMessage = error.response.data.errors.email[0];
          } else {
            this.errorMessage = "Es ist ein Fehler aufgetreten.";
          }
        });
    },
  },
  mounted() {},
  created() {},
  computed: {},
};
</script>

<style>
</style>
